export default __webpack_public_path__ + "static/media/missing-product-type.9de41245.png";